module.exports = __webpack_public_path__ + "static/media/internet.9a0f9742.png";